import { call, put } from 'redux-saga/effects';
import bugsnagClient from '../../../../services/bugsnag/bugsnag';
import { fetchAnalyticTeamAction } from '../../analyticTeam/fetchTeam/action';
import { fetchAnalyticTeamDataAction } from '../../analyticData/fetchTeamData/action';
import { showSnackbar } from '../../../../state/snackbar/snackbarSlice';
import { backendClient } from '../../../../services/api/backend-client';

export function* addTeamMemberSaga(action) {
    const { teamId, uids = [], role } = action.payload || {};
    const skipFetch = action.meta?.skipFetch === true;
    const silent = action.meta?.silent === true;

    try {
        if (!teamId) throw new Error("teamId is required");
        if (!Array.isArray(uids) || uids.length === 0) {
            throw new Error("uids[] is required");
        }

        if (uids.length === 1) {
            yield call(
                [backendClient, backendClient.post],
                `teams/${encodeURIComponent(teamId)}/members`,
                { uid: uids[0], role }
            );
        } else {
            yield call(
                [backendClient, backendClient.post],
                `teams/${encodeURIComponent(teamId)}/members/batch`,
                { uids, role }
            );
        }

        if (!skipFetch) {
            yield put(fetchAnalyticTeamAction())
            yield put(fetchAnalyticTeamDataAction({ teamId, range: 'week' }));
        }

        if (!silent) {
            yield put(showSnackbar({
                message: `Member${uids.length > 1 ? "s" : ""} added successfully.`,
                severity: "success",
            }));
        }
    } catch (err) {
        bugsnagClient.notify(err);
        console.error("Failed to add analytic team member(s):", err?.message);
        yield put(showSnackbar({ message: "Failed to add team member(s).", severity: "error" }));
    }
}